import JwtUtilService from '@/services/jwt.util.service'

export default {
  authenticated: !!JwtUtilService.getToken(),
}
